// タブ切り替え
document.querySelectorAll('.ss-tab').forEach(function(tab) {
  tab.addEventListener('click', function() {
    var target = this.getAttribute('data-tab');

    document.querySelectorAll('.ss-tab').forEach(function(t) {
      t.classList.remove('active');
    });
    document.querySelectorAll('.ss-panel').forEach(function(p) {
      p.classList.remove('active');
    });

    this.classList.add('active');
    var panel = document.querySelector('.ss-panel[data-panel="' + target + '"]');
    if (panel) {
      panel.classList.add('active');
      animateCards(panel);
    }
  });
});

// カードのフェードインアニメーション
function animateCards(panel) {
  var cards = panel.querySelectorAll('.ss-card');
  cards.forEach(function(card) {
    card.classList.remove('visible');
  });
  cards.forEach(function(card, i) {
    setTimeout(function() {
      card.classList.add('visible');
    }, i * 60);
  });
}

// 初期表示のアニメーション
var initialPanel = document.querySelector('.ss-panel.active');
if (initialPanel) {
  animateCards(initialPanel);
}


// 大阪詳細アコーディオン（スマホ用）
var toggleBtn = document.querySelector('.ss-osaka__toggle');
if (toggleBtn) {
  toggleBtn.addEventListener('click', function() {
    var accordion = document.querySelector('.ss-osaka__accordion');
    var expanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !expanded);
    accordion.classList.toggle('open');
  });
}
